import { HttpService } from './http.service';

export interface City {
  id: string;
  name: string;
}

const CityService = {
  getAllCities: async (): Promise<City[]> => {
    try {
      const response = await HttpService.get<City[]>('/api/cities');
      return response.data;
    } catch (error) {
      return [];
    }
  }
};

export default CityService;
